import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { UserService} from '../app/user.service';
import { Observable } from 'rxjs';
import { tap, map, take } from 'rxjs/operators';

import { AngularFireAuth } from '@angular/fire/auth';

@Injectable()
export class AuthService implements CanActivate {
  constructor(private userService: UserService, private router: Router, public afAuth: AngularFireAuth) {}

  /** Lets the router know whether the user can visit the route */
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
      return this.userService.user$.pipe(
           take(1),
           map(user => !!user),
           tap(loggedIn => {
             if (!loggedIn) {
               console.log('access denied');
             }
         })
    );
  }
}